<div class="modal-header">
  <div class="modal-title">{{ cmsSearchWidgetCopy.whoIsFlying }}</div>
  <div class="modal-subtitle">
    {{ cmsSearchWidgetCopy.selectTravelAge }}
  </div>
</div>
<div class="modal-body">
  <form [formGroup]="travelersFormGroup">
    <div class="row traveler-row">
      <div class="col-7 m-auto">
        <div class="row">
          {{ cmsSearchWidgetCopy.adult }}
        </div>
        <div class="row">
          <span class="fs-6 p-0 text-black-50">{{
            cmsSearchWidgetCopy.adultAge
          }}</span>
        </div>
      </div>
      <div class="col-5 m-auto text-end">
        <div class="row text-center">
          <div class="col">
            <button
              id="btn-adult-remove"
              (click)="onAdultRemove()"
              class="btn-circle minus"
              aria-label="remove adult"
              data-qa="btn-adult-remove"
              [disabled]="adultCount === 0"
            >
              <span class="visually-hidden">{{
                cmsSearchWidgetCopy.removeAdult
              }}</span>
            </button>
          </div>
          <div class="col m-auto">
            <span class="counter fw-bold">{{ adultCount }}</span>
          </div>
          <div class="col">
            <button
              id="btn-adult-add"
              (click)="onAdultAdd()"
              class="btn-circle plus"
              aria-label="add adult"
              data-qa="btn-adult-add"
              [disabled]="totalTravelerCount() >= maxTravelerCount"
            >
              <span class="visually-hidden">{{
                cmsSearchWidgetCopy.addAdult
              }}</span>
            </button>
            <input
              type="hidden"
              name="adultCount"
              formControlName="adultCount"
              value=""
            />
          </div>
        </div>
      </div>
    </div>

    <div class="row traveler-row">
      <div class="col-7 m-auto">
        <div class="row">
          {{ cmsSearchWidgetCopy.youth }}
        </div>
        <div class="row">
          <span class="fs-6 text-black-50">
            {{ cmsSearchWidgetCopy.youthAge }}
          </span>
        </div>
      </div>
      <div class="col-5 m-auto text-end">
        <div class="row text-center">
          <div class="col">
            <button
              id="btn-child-remove"
              (click)="onYouthRemove()"
              class="btn-circle minus"
              aria-label="remove youth"
              data-qa="btn-youth-remove"
              [disabled]="youthCount === 0"
            >
              <span class="visually-hidden">
                {{ cmsSearchWidgetCopy.removeYouth }}
              </span>
            </button>
          </div>
          <div class="col m-auto">
            <span class="counter fw-bold">{{ youthCount }}</span>
          </div>
          <div class="col">
            <button
              id="btn-youth-add"
              (click)="onYouthAdd()"
              class="btn-circle plus"
              aria-label="add youth"
              data-qa="btn-youth-add"
              [disabled]="totalTravelerCount() >= maxTravelerCount"
            >
              <span class="visually-hidden">
                {{ cmsSearchWidgetCopy.addYouth }}
              </span>
            </button>
            <input
              type="hidden"
              name="youthCount"
              formControlName="youthCount"
              value=""
            />
          </div>
        </div>
      </div>
    </div>

    <div class="row traveler-row">
      <div class="col-7 m-auto">
        <div class="row">
          {{ cmsSearchWidgetCopy.child }}
        </div>
        <div class="row">
          <span class="fs-6 text-black-50">
            {{ cmsSearchWidgetCopy.childAge }}
          </span>
        </div>
      </div>
      <div class="col-5 m-auto text-end">
        <div class="row text-center">
          <div class="col">
            <button
              id="btn-child-remove"
              (click)="onChildRemove()"
              class="btn-circle minus"
              aria-label="remove child"
              data-qa="btn-child-remove"
              [disabled]="childCount === 0"
            >
              <span class="visually-hidden">{{
                cmsSearchWidgetCopy.removeChild
              }}</span>
            </button>
          </div>
          <div class="col m-auto">
            <span class="counter fw-bold">{{ childCount }}</span>
          </div>
          <div class="col">
            <button
              id="btn-child-add"
              (click)="onChildAdd()"
              class="btn-circle plus"
              aria-label="add child"
              data-qa="btn-child-add"
              [disabled]="totalTravelerCount() >= maxTravelerCount"
            >
              <span class="visually-hidden">{{
                cmsSearchWidgetCopy.addChild
              }}</span>
            </button>
            <input
              type="hidden"
              name="childCount"
              formControlName="childCount"
              value=""
            />
          </div>
        </div>
      </div>
    </div>

    <div class="row traveler-row">
      <div class="col-7 m-auto">
        <div class="row">
          {{ cmsSearchWidgetCopy.infantInOwnSeat }}
        </div>
        <div class="row">
          <span class="fs-6 text-black-50">
            {{ cmsSearchWidgetCopy.infantAge }}
          </span>
        </div>
      </div>
      <div class="col-5 m-auto text-end">
        <div class="row text-center">
          <div class="col">
            <button
              id="btn-infant-in-own-seat-remove"
              (click)="onInfantInOwnSeatRemove()"
              class="btn-circle minus"
              aria-label="remove infant in own seat"
              data-qa="btn-infant-in-own-seat-remove"
              [disabled]="infantInOwnSeatCount === 0"
            >
              <span class="visually-hidden">
                {{ cmsSearchWidgetCopy.removeInfantInSeat }}
              </span>
            </button>
          </div>
          <div class="col m-auto">
            <span class="counter fw-bold">{{ infantInOwnSeatCount }}</span>
          </div>
          <div class="col">
            <button
              id="btn-infant-in-own-seat-add"
              (click)="onInfantInOwnSeatAdd()"
              class="btn-circle plus"
              aria-label="add infant in own seat"
              data-qa="btn-infant-in-own-seat-add"
              [disabled]="totalTravelerCount() >= maxTravelerCount"
            >
              <span class="visually-hidden">
                {{ cmsSearchWidgetCopy.addInfantInSeat }}
              </span>
            </button>
            <input
              type="hidden"
              name="infantInOwnSeatCount"
              formControlName="infantInOwnSeatCount"
              value=""
            />
          </div>
        </div>
      </div>
    </div>

    <div class="row traveler-row">
      <div class="col-7 m-auto">
        <div class="row">
          {{ cmsSearchWidgetCopy.infantParentLap }}
        </div>
        <div class="row">
          <span class="fs-6 text-black-50">
            {{ cmsSearchWidgetCopy.infantAge }}</span
          >
        </div>
        <div *ngIf="infantCount > 0" class="row">
          <span class="fs-6 infant-fee">{{
            cmsSearchWidgetCopy.perInfantPrice
          }}</span>
        </div>
      </div>
      <div class="col-5 m-auto text-end">
        <div class="row text-center">
          <div class="col">
            <button
              id="btn-infant-remove"
              (click)="onInfantRemove()"
              class="btn-circle minus"
              aria-label="remove infant"
              data-qa="btn-infant-remove"
              [disabled]="infantCount === 0"
            >
              <span class="visually-hidden">{{
                cmsSearchWidgetCopy.removeInfant
              }}</span>
            </button>
          </div>
          <div class="col m-auto">
            <span class="counter fw-bold">{{ infantCount }}</span>
          </div>
          <div class="col">
            <button
              id="btn-infant-add"
              (click)="onInfantAdd()"
              class="btn-circle plus"
              aria-label="add infant"
              data-qa="btn-infant-add"
              [disabled]="
                infantCount >= adultCount ||
                totalTravelerCount() >= maxTravelerCount
              "
            >
              <span class="visually-hidden">{{
                cmsSearchWidgetCopy.addInfant
              }}</span>
            </button>
            <input
              type="hidden"
              name="infantCount"
              formControlName="infantCount"
              value=""
            />
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
<app-traveler-picker-modal-submit-button
  [cmsSearchWidgetCopy]="cmsSearchWidgetCopy"
  (onSubmit)="onNextClick()" >
</app-traveler-picker-modal-submit-button>
